import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesPackageEditMain } from './modules/ui/Main';

const PackageEditPage = (
  <SuspensePage>
    <PagesPackageEditMain />
  </SuspensePage>
);

export default PackageEditPage;
